import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["documentTagStore", "value", "onChange", "readOnly"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import Async from 'react-select/async';
import styles from './TagSelect.m.sass';
var TagSelect = function TagSelect(_ref) {
  var documentTagStore = _ref.documentTagStore,
    value = _ref.value,
    _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement(Async, _extends({
    placeholder: "Select tags"
  }, props, {
    styles: {
      control: function control(provided, state) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          border: '1px solid #DDDDE9',
          borderColor: state.isFocused ? '' : undefined,
          backgroundColor: '#FAFBFC',
          boxShadow: 'none',
          fontSize: '0.85rem',
          borderRadius: '2px',
          padding: 0,
          height: 'auto'
        });
      }
    },
    isDisabled: props.disabled || readOnly,
    isMulti: true,
    defaultOptions: true,
    loadOptions: function loadOptions(inputValue) {
      return documentTagStore.fetchTags().then(function (resp) {
        var data = resp.data;
        if (inputValue) {
          data = data.filter(function (x) {
            return x.label.toLowerCase().includes(inputValue.toLowerCase());
          });
        }
        return data;
      });
    },
    value: value.map(function (t) {
      return documentTagStore.tags.get(t);
    }),
    getOptionValue: function getOptionValue(v) {
      return v.id;
    },
    getOptionLabel: function getOptionLabel(v) {
      return v.label;
    },
    onChange: function onChange(opts) {
      return _onChange((opts || []).map(function (x) {
        return x.id;
      }));
    }
  })));
};
export default observer(TagSelect);
//# sourceMappingURL=index.js.map
